import React, { useMemo } from 'react';
import { Button, Flex, Text, ToggleButton } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './TwoFactorScreen.css';
const {
  t
} = I18N.ns('login.twoFactor.TwoFactorMethodsList');
export default function TwoFactorMethodsList({
  user,
  methods,
  onToggleMethod,
  onViewCodes,
  required
}) {
  const activeMethods = useMemo(() => {
    return methods.filter(method => {
      return user?.twoFactor?.methods?.[method.type]?.active;
    });
  }, [methods, user]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, methods.map(method => {
    const isEnabled = user?.twoFactor?.methods?.[method.type]?.active;
    return /*#__PURE__*/React.createElement(Flex, {
      key: method.type,
      justify: "space-between",
      align: "center",
      className: S.cardSection
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "col"
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "rowM",
      align: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "subtitle"
    }, typeof method.name === 'function' ? method.name() : method.name), isEnabled && /*#__PURE__*/React.createElement("img", {
      width: 18,
      height: 18,
      alt: t('altSuccess'),
      src: "https://molten-ui-assets.storage.googleapis.com/two-step-success.png"
    })), /*#__PURE__*/React.createElement(Text, null, typeof method.description === 'function' ? method.description() : method.description)), (!isEnabled || !required || activeMethods.length > 1) && /*#__PURE__*/React.createElement(ToggleButton, {
      variant: "twoStepToggle",
      onChange: onToggleMethod,
      value: isEnabled,
      on: t('on'),
      off: t('off'),
      eventData: {
        method
      }
    }));
  }), /*#__PURE__*/React.createElement(Flex, {
    className: S.cardSection,
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "linkNoPad",
    onClick: onViewCodes
  }, t('viewBackupCodes'))));
}